// jacques-andre-editeur\proshop-v2\frontend\src\constants.js
// export const BASE_URL =
//   process.env.NODE_ENV === 'develeopment' ? 'http://localhost:5000' : '';
//export const BASE_URL = ''; // If using proxy
export const BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
export const BOOKS_URL = '/api/books';
export const BOOKSCOLLECTIONS_URL = '/api/booksCollections';
export const AUTHORS_URL = '/api/authors';
export const NEWS_URL = '/api/news';
export const ALAUNE_URL = '/api/alaune';
export const USERS_URL = '/api/users';
export const SUBSCRIBERS_URL = '/api/subscribers';
export const ORDERS_URL = '/api/orders';
// export const PAYPAL_URL = '/api/config/paypal';
